import {
  Component,
  Element,
  Event,
  EventEmitter,
  Prop,
  State,
  Watch,
  h
} from "@stencil/core";
import { Control } from "@genexus/designer-common";

import {
  getIconPath
} from "@genexus/mercury";

import { getBreadcrumb, isControlDragActiveTarget, isControlDraggable } from "../../../utils";
import { DesignerToolArrangeObserver } from "../designer-tool-arrange/designer-tool-arrange-observer";
import { DesignerToolSelectEvent } from "../designer-tools-types";

@Component({
  styleUrl: "designer-tool-bar.scss",
  tag: "gx-designer-tool-bar"
})
export class DesignerToolBar {

  @Element() el: HTMLElement;
  @Prop() control: Control;
  @State() parentControl: Control;
  @State() dragHidden = false;
  @State() buttonsHidden = false;
  @State() buttonInfoHidden = false;
  @State() buttonTaskHidden = false;
  @State() buttonSelectHidden = false;

  componentWillLoad() {
    this.initialize();
  }

  componentDidLoad() {
    DesignerToolArrangeObserver.observe(this.el);
  }

  disconnectedCallback() {
    DesignerToolArrangeObserver.unobserve(this.el);
  }

  @Watch("control")
  watchControl() {
    this.initialize();
  }

  @Event() selectControl: EventEmitter<DesignerToolSelectEvent>;

  handleSelectParentClick(event: MouseEvent) {
    if (this.parentControl) {
      this.selectControl.emit({
        add: event.ctrlKey,
        controlId: this.parentControl.site.id
      });
      event.stopPropagation();
    }
  }

  private initialize() {
    const isDragTarget = isControlDragActiveTarget(this.control);
    this.initializeButtonSelect();

    this.dragHidden = isDragTarget || !isControlDraggable(this.control);
    this.buttonSelectHidden = isDragTarget || !this.parentControl;
    this.buttonsHidden =
      this.buttonInfoHidden && this.buttonTaskHidden && this.buttonSelectHidden;
  }

  private initializeButtonSelect() {
    let bc = getBreadcrumb(this.control);
    this.parentControl = bc.length > 0 ? bc[0] : undefined;
  }

  render() {
    return [
      <div class="bar">
        <gx-designer-tool-drag
          class="drag"
          control={this.control}

        />
        <gx-designer-tool-identity class="identity" control={this.control} />
        <ul class="buttons" hidden={this.buttonsHidden}>
          <li class="info" hidden={this.buttonInfoHidden}>
            <button class="button-tertiary button-icon-only">
              <ch-image src={
                getIconPath({
                  category: "gemini-tools",
                  name: "notice",
                  colorType: "primary"
                })
                }
                class="icon-md" 
              />
            </button>
          </li>
          <li class="task" hidden={this.buttonTaskHidden}>
            <button class="button-tertiary button-icon-only">
              <ch-image 
                src={
                  getIconPath({
                    category: "gemini-tools",
                    name: "settings",
                    colorType: "primary"
                  })
                }
                class="icon-md" 
              />
            </button>
          </li>
          <li class="select" hidden={this.buttonSelectHidden}>
            <button class="button-tertiary button-icon-only">
              <ch-image
                src={
                  getIconPath({
                    category: "navigation",
                    name: "level-up",
                    colorType: "primary"
                  })
                }
                class="icon-md parent" 
                onClick={this.handleSelectParentClick.bind(this)} 
              />
            </button>
            <gx-designer-tool-breadcrumb
              control={this.control}
              class="location-top"
              data-gx-designer-tool-arrange-locations="location-top location-bottom"
            />
          </li>
        </ul>
      </div>,
      <div class="arrow" />
    ];
  }
}
